<template>
  <div>
    <Card shadow class="content">
      <div class="main">
        <Alert v-if="error" show-icon type="error">
          获取数据失败
          <a style="float: right;" v-on:click="getLogs()"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <div v-else>
          <Row>
            <Form ref="searchForm" inline @submit.native.prevent :model="searchForm" :label-width="65">
              <FormItem label="资源类型" v-if="!fixedObject">
                <Select v-model="searchForm.object" style="width: 150px;" placeholder="" filterable clearable transfer>
                  <Option v-for="item in objects" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="资源ID" :label-width="50" v-if="!fixedObjectId">
                <Input v-model="searchForm.object_id" style="width: 150px;" />
              </FormItem>
              <FormItem label="操作内容">
                <Input v-model="searchForm.content" style="width: 150px;" />
              </FormItem>
              <FormItem label="操作用户">
                <Select v-model="searchForm.user" placeholder="" filterable clearable transfer style="width: 150px;">
                  <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
                </Select>
              </FormItem>
              <FormItem label="状态" :label-width="40">
                <Select v-model="searchForm.status" style="width: 150px;" placeholder="" clearable transfer>
                  <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="操作时间">
                <DatePicker type="daterange"
                            placement="bottom-end"
                            placeholder=""
                            v-model="searchDatetime"
                            :options="searchDateOption"
                            @on-change="searchDateTimeChange"
                            style="width: 200px;"></DatePicker>
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getLogs()">搜索</Button>
                <Button @click="searchFormReset" style="margin-left: 10px">重置</Button>
              </FormItem>
            </Form>
          </Row>
          <Table
            :loading="tableLoading"
            ref="table"
            :data="logs"
            :columns="columns">
          </Table>
          <div style="margin: 10px 0; overflow: hidden;">
            <div style="float: left;">
              当前显示 {{ logs.length }} 条记录，总共 {{ count }} 条记录
            </div>
            <div style="float: right;">
              <page
                :total="count"
                :current="page"
                :page-size="size"
                @on-change="getLogs"></page>
            </div>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getOperateLogs } from '@/api/private-cloud/general'
import { GetALLUsers } from '@/api/user'
import moment from 'moment'

export default {
  name: 'operate-log',
  components: {
    moment
  },
  props: {
    fixedObject: {
      type: String,
      default: ''
    },
    fixedObjectId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      error: false,
      logs: [],
      columns: [
        {
          title: '资源类型',
          key: 'object_verbose',
          align: 'center',
          minWidth: 150
        },
        {
          title: '资源ID',
          key: 'object_id',
          align: 'center',
          minWidth: 250
        },
        {
          title: '操作内容',
          key: 'content',
          align: 'center',
          minWidth: 200
        },
        {
          title: '错误信息',
          key: 'error_msg',
          align: 'center',
          minWidth: 200,
          tooltip: true,
          render: (h, params) => {
            return h('span', params.row.error_msg ? params.row.error_msg : '无')
          }
        },
        {
          title: '操作用户',
          key: 'user_name',
          align: 'center',
          minWidth: 150
        },
        {
          title: '操作时间',
          key: 'datetime',
          align: 'center',
          minWidth: 200,
          render: (h, params) => {
            return h('span', params.row.datetime ? moment(params.row.datetime).format('YYYY-MM-DD HH:mm:ss') : '')
          }
        },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            let color = params.row.status
            let text = params.row.status
            if (params.row.status === 'success') {
              color = 'success'
              text = '成功'
            } else if (params.row.status === 'error') {
              color = 'error'
              text = '失败'
            }
            return h('Badge', {
              props: {
                text: text,
                status: color
              }
            })
          }
        }
      ],
      count: 0,
      page: 1,
      size: 15,
      tableLoading: false,
      searchDatetime: '',
      searchDateOption: {
        shortcuts: [
          {
            text: '7天内',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              return [start, end]
            }
          },
          {
            text: '14天内',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
              return [start, end]
            }
          },
          {
            text: '30天内',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            }
          },
          {
            text: '90天内',
            value () {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            }
          }
        ]
      },
      searchForm: {
        object: '',
        object_id: '',
        status: '',
        content: '',
        user: '',
        datetime_after: '',
        datetime_before: ''
      },
      objects: [
        {value: 'server', label: '实例'},
        {value: 'key_pair', label: '密钥对'},
        {value: 'aggregate', label: '主机聚合'},
        {value: 'flavor', label: '实例类型'},
        {value: 'image', label: '镜像'},
        {value: 'image_file', label: '镜像文件'},
        {value: 'volume', label: '云硬盘'},
        {value: 'volume_snapshot', label: '云硬盘快照'},
        {value: 'volume_backup', label: '云硬盘备份'},
        {value: 'project', label: '租户'},
        {value: 'project_compute_quota', label: '租户计算资源配额'},
        {value: 'project_storage_quota', label: '租户存储资源配额'},
        {value: 'project_network_quota', label: '租户网络资源配额'},
        {value: 'role', label: '角色'},
        {value: 'user', label: '用户'},
        {value: 'network', label: '虚拟网络'},
        {value: 'subnet', label: '虚拟网络子网'},
        {value: 'floating_ip', label: '浮动IP'},
        {value: 'port', label: '虚拟网络端口'},
        {value: 'router', label: '虚拟路由'},
        {value: 'security_group', label: '安全组'},
        {value: 'security_group_rule', label: '安全组规则'}
      ],
      statusList: [
        { value: 'success', label: '成功' },
        { value: 'error', label: '失败' }
      ],
      userList: []
    }
  },
  created: function () {
    this.getLogs()
    this.getAllUserData()
  },
  mounted: function () {
    if (this.fixedObject) {
      this.searchForm.object = this.fixedObject
    }
    if (this.fixedObjectId) {
      this.searchForm.object_id = this.fixedObjectId
    }
  },
  methods: {
    getLogs (value = 1) {
      this.page = value
      this.searchForm.page = this.page
      this.searchForm.size = this.size
      this.tableLoading = true
      getOperateLogs(this.searchForm).then(res => {
        this.logs = res.data.results
        this.count = res.data.count
        this.error = false
        this.tableLoading = false
      }).catch(res => {
        this.error = true
        this.tableLoading = false
        console.error(res.response)
      })
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    searchDateTimeChange (value) {
      this.searchForm.datetime_after = value[0]
      this.searchForm.datetime_before = value[1]
    },
    searchFormReset () {
      this.searchDatetime = ''
      this.searchForm = {
        object: this.fixedObject,
        object_id: this.fixedObjectId,
        status: '',
        content: '',
        user: '',
        datetime_after: '',
        datetime_before: ''
      }
    }
  }
}
</script>

<style scoped>

</style>
